import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const FreezeListingModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "FreezeListingModalContainer" */
      './FreezeListingModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
